<template>
    <div class="cgu-page">
        <div class="cgu-header">
            <div class="cgu-header-content">
                <h1 class="cgu-main-title">Conditions Générales d'Utilisation</h1>
                <p class="cgu-subtitle">MyEcocar - Plateforme de Covoiturage</p>
            </div>
        </div>

        <div class="cgu-container">
            <!-- Table des matières / Sommaire -->
            <div class="cgu-toc">
                <h2 class="toc-title">Sommaire</h2>
                <ol class="toc-list">
                    <li><a href="#section1" class="toc-link">Champ d'application et définitions</a></li>
                    <li><a href="#section2" class="toc-link">Utilisation du site</a></li>
                    <li><a href="#section3" class="toc-link">Responsabilité</a></li>
                    <li><a href="#section4" class="toc-link">Interruption et suspension de l'accès au site</a></li>
                    <li><a href="#section5" class="toc-link">Traitement des données personnelles</a></li>
                    <li><a href="#section6" class="toc-link">Covoiturage et assurance</a></li>
                    <li><a href="#section7" class="toc-link">Litiges et oppositions</a></li>
                </ol>
            </div>

            <!-- Contenu des sections -->
            <div class="cgu-content">
                <!-- Section 1 -->
                <section id="section1" class="cgu-section">
                    <h2 class="section-title">1. Champ d'application et définitions</h2>
                    
                    <p class="section-text">Les présentes conditions générales s'appliquent aux services proposés par le site MyEcocar, inscrit au répertoire des Associations de Strasbourg. Covoiturage MyEcocar.</p>

                    <div class="definitions-box">
                        <h3>Définitions</h3>
                        <dl class="definitions-list">
                            <dt><strong>Conditions Générales d'Utilisation (CGU)</strong></dt>
                            <dd>désigne les Conditions Générales d'Utilisation ainsi que le code de bonne conduite avec lequel les Utilisateurs du Site.</dd>

                            <dt><strong>Service</strong></dt>
                            <dd>désigne tout service fourni à un Utilisateur par l'intermédiaire du Site, étant en outre reconnu que MyEcocar n'est affilié à aucun contrat de transport.</dd>

                            <dt><strong>Compte utilisateur</strong></dt>
                            <dd>désigne le compte qui doit être créé pour devenir Utilisateur et ainsi pouvoir accéder aux services proposés par le Site.</dd>

                            <dt><strong>Le site</strong></dt>
                            <dd>désigne le site MyEcocar et, d'une manière générale, tout site Internet édité ou coédité par MyEcocar.</dd>

                            <dt><strong>Le chauffeur</strong></dt>
                            <dd>désigne la personne physique se proposant sur le site de transporter une autre personne physique moyennant une rémunération dont le montant est défini à l'avance, et pour un trajet et un horaire déterminés par elle.</dd>

                            <dt><strong>Le passager</strong></dt>
                            <dd>désigne la personne physique qui a accepté une proposition de transport du Chauffeur.</dd>

                            <dt><strong>L'utilisateur</strong></dt>
                            <dd>désigne tout Passager ou tout Conducteur ayant souscrit aux Conditions d'Utilisation du site MyEcocar.fr.</dd>

                            <dt><strong>Le trajet</strong></dt>
                            <dd>désigne l'acte de prestation accepté et effectué par le Chauffeur qui s'engage ainsi à transporter le Passager en échange d'une somme déterminée à l'avance, selon un itinéraire et un horaire définis.</dd>

                            <dt><strong>Participation aux frais, prix du covoiturage</strong></dt>
                            <dd>désigne la somme d'argent que le Conducteur demande au Passager et que ce dernier accepte comme sa Contribution aux frais de déplacement afférents au Trajet. Cette Contribution est limitée au seul partage des frais du Trajet et aucun profit ne peut être réalisé par le Conducteur. A défaut, le Conducteur pourra voir cette prestation non agréée par MyEcocar être requalifiée, notamment en étant considéré comme un professionnel et il supportera seul les risques de cette requalification.</dd>
                        </dl>
                    </div>

                    <h3 class="subsection-title">1.1 Condition d'utilisation</h3>
                    <p class="subsection-text"><strong>1.1.1</strong> L'utilisation du Site suppose l'acceptation des présentes Conditions Générales d'Utilisation. Lors de la création du Compte Utilisateur, le nouvel Utilisateur doit cocher la case « vous acceptez nos Conditions Générales d'Utilisation ». L'accès aux services proposés n'est autorisé qu'après acceptation des présentes CGU L'acceptation de ces CGU est complète et forme un tout indissociable, il est donc impossible pour l'Utilisateur de choisir de ne voir qu'une partie des CGU appliquées ou d'émettre des réserves.</p>

                    <p class="subsection-text"><strong>1.1.2</strong> L'acceptation des CGU implique nécessairement celle de la Charte de bonne conduite ainsi que celle de l'article relatif au traitement des données personnelles des utilisateurs. En cas de manquement à l'une quelconque des obligations prévues aux présentes, MyEcocar se réserve le droit de supprimer le Compte Utilisateur concerné. MyEcocar peut également modifier à tout moment les CGU, les fonctionnalités proposées par le site et les règles de fonctionnement du Service.</p>

                    <p class="subsection-text"><strong>1.1.3</strong> Toute modification prend effet immédiatement lors de la mise en ligne des CGU, que tout Utilisateur reconnaît avoir préalablement consultées.</p>

                    <p class="subsection-text"><strong>1.1.4</strong> Dans le cas où la modification intervient après versement par le Passager d'une somme d'argent correspondant à la Participation aux Frais, cette modification ne s'applique pas à la transaction en cours.</p>
                </section>

                <!-- Section 2 -->
                <section id="section2" class="cgu-section">
                    <h2 class="section-title">2. Utilisation du site</h2>
                    
                    <p class="section-text">Pour bénéficier des services en ligne que propose MyEcocar, il est indispensable que chaque Utilisateur s'enregistre au préalable, et qu'il crée à cet effet un Compte Utilisateur au travers duquel il livre des données personnelles, notamment nom, prénom, âge, civilité, un numéro de téléphone valide et adresse e-mail. Ces données sont nécessaires pour une connexion optimale des personnes. Lors de son inscription, le nouvel Utilisateur doit certifier qu'il est âgé de plus de 18 ans.</p>

                    <p class="section-text">S'il s'avère qu'un Utilisateur communique des informations qui s'avèrent erronées ou frauduleuses, MyEcocar ne pourra en aucun cas être tenu pour responsable. De plus, l'utilisateur ne doit en aucun cas créer ou utiliser d'autres comptes que celui qu'il a initialement créé, ni sous sa propre identité ni sous celle d'un tiers.</p>

                    <h3 class="subsection-title">2.1 Utilisation du service</h3>
                    <p class="subsection-text"><strong>2.1.1</strong> En s'inscrivant sur le Site, le nouvel Utilisateur s'engage à n'utiliser le service MyEcocar qu'à des fins de contact, à titre non professionnel et non commercial, avec des personnes souhaitant effectuer un trajet ensemble.</p>

                    <p class="subsection-text"><strong>2.1.2</strong> S'il s'avère que les services proposés par le Site sont utilisés à des fins professionnelles ou commerciales, MyEcocar ne pourra en aucun cas être tenu pour responsable.</p>

                    <p class="subsection-text"><strong>2.1.3</strong> Toute activité exercée sur le Site et qui entraînerait une situation de bénéfice pour l'Usager, du fait de la nature des Trajets proposés par ce dernier, de leur fréquence ou du nombre de Passagers transportés, pourra être considérée comme commerciale. La Contribution aux Frais demandée à ses Passagers par le Conducteur doit en effet rester uniquement une Contribution aux Frais, et ne doit être assortie d'aucun avantage pour le Conducteur. Ce dernier s'engage ainsi à calculer tous les frais afférents au Trajet qu'il propose (notamment carburant, péages, frais de réparation, contrôle technique, entretien, amortissement et assurance de son véhicule) et à s'assurer qu'il ne tirera aucun avantage du montant demandé à ses Passagers.</p>

                    <p class="subsection-text">L'activité de MyEcocar étant strictement limitée à la mise en relation de personnes proposant un Trajet en covoiturage entre particuliers à titre non professionnel, les Chauffeurs ne peuvent donc être considérés comme exerçant une activité de transport. En aucun cas l'équipe MyEcocar n'intervient sur les Trajets, les destinations ou les horaires, le site MyEcocar ne constituant qu'une simple plateforme. Le Chauffeur n'a pas à assurer les obligations d'un transporteur. Le Passager ne peut donc s'attendre à la réalisation de ce type de service.</p>

                    <h3 class="subsection-title">2.2 La réservation</h3>
                    <p class="subsection-text"><strong>2.2.1</strong> Afin de réduire le risque d'annulation de dernière minute par les utilisateurs et d'augmenter le capital sécurité, MyEcocar propose à l'ensemble de ses Utilisateurs un service de Réservation confirmée par l'envoi d'un SMS. Toutefois, si notamment l'un de ces risques survenait, la responsabilité de MyEcocar ne pourra en aucun cas être engagée.</p>

                    <h3 class="subsection-title">2.3 Réservation et confirmation</h3>
                    <p class="subsection-text"><strong>2.3.1</strong> Lorsque le Chauffeur propose un Trajet sur le Site, il précise l'heure de départ et l'heure d'arrivée, la date et les heures, ainsi que les différentes modalités. La réservation par le Passager d'une ou plusieurs places depuis le Site ne peut se faire que s'il a créé un compte sur le site. La réservation est confirmée par la réception d'un SMS. Le conducteur et le passager sont alors engagés. Un email est également envoyé au passager et au chauffeur par lequel ils sont informés de la confirmation de la réservation. Toute réservation étant nominative, il est nécessaire que le conducteur et le passager correspondent tous les deux à l'identité préalablement communiquée à MyEcocar.</p>

                    <p class="subsection-text"><strong>2.3.2</strong> Tarif covoiturage : MyEcocar n'applique pas de commission sur les réservations, l'utilisation du site est gratuite.</p>

                    <h3 class="subsection-title">2.4 Paiement du chauffeur à la fin du trajet</h3>
                    <p class="subsection-text"><strong>2.4.1</strong> La contribution du passager aux frais s'effectue exclusively par paiement direct au conducteur.</p>

                    <p class="subsection-text"><strong>2.4.2</strong> En cas d'incident de paiement (notamment en cas de refus de paiement par le passager), MyEcocar n'est en aucun cas tenu pour responsable ou redevable vis-à-vis du passager.</p>

                    <p class="subsection-text"><strong>2.4.3</strong> Le chauffeur se présente à l'heure et au lieu convenus ; à défaut, ou en cas d'annulation sans en avoir averti les passagers ayant réservé, MyEcocar se réserve le droit de conserver les informations relatives à cette annulation dans la base de données de son profil et/ou de publier ces informations sur son profil en ligne et/ou de suspendre l'accès du Chauffeur au Site.</p>

                    <p class="subsection-text"><strong>2.4.4</strong> Si après la réservation d'un ou plusieurs Passagers, le Conducteur décide de modifier l'une quelconque des conditions du Trajet avec Réservation comme initialement prévu, le Conducteur s'engage à contacter sans délai les Passagers ayant réservé sur son Trajet afin de les obtenir leur accord à cette modification dudit Voyage. En cas de refus de cette modification par un Passager, ce dernier est en droit de procéder à l'annulation totale de sa réservation.</p>

                    <h3 class="subsection-title">2.5 Documents obligatoires</h3>
                    <p class="subsection-text"><strong>2.5.1</strong> Le Conducteur doit être assuré conformément à la législation en vigueur et vérifier avant tout Trajet l'entière validité de cette assurance. Il est également impératif qu'il ait un permis de conduire valide. A titre purement indicatif, les assureurs admettent couramment qu'un Passager qui contribue au coût du voyage est considéré comme transporté gratuitement, qu'il est un tiers dans le véhicule, et que par conséquent l'assurance responsabilité civile minimale généralisée en Europe couvre il.</p>

                    <p class="subsection-text"><strong>2.5.2</strong> Il appartient à chaque Passager et Conducteur de vérifier que tel est bien le cas de l'assurance du Conducteur. Si le Chauffeur utilise un véhicule de société, il doit notamment vérifier que le transport de personnes est autorisé par son assurance et que celle-ci couvre toute personne transportée ainsi que les éventuelles conséquences d'un incident pouvant survenir lors d'un trajet en covoiturage.</p>

                    <p class="subsection-text"><strong>2.5.3</strong> Le Passager et le Conducteur sont informés du fait que les compagnies d'assurances peuvent refuser de couvrir les dommages qui pourraient être causés lors d'un Trajet pour lequel le Conducteur aurait réalisé un bénéfice ou se serait trouvé dans une situation assimilable à une activité professionnelle. Dans ce cas, il supporterait seul les conséquences financières liées à l'absence de couverture par son assureur d'un éventuel accident, et la responsabilité de MyEcocar ne pourrait être engagée. Cette dernière se réserve le droit de procéder à la suspension immédiate du compte de l'Utilisateur et des sommes qui y figurent, et d'informer les autorités compétentes de toute activité à caractère professionnel.</p>

                    <h3 class="subsection-title">2.6 Gestion des litiges</h3>
                    <p class="subsection-text"><strong>2.6.1</strong> Un service de résolution des litiges est mis à la disposition de ses Utilisateurs par MyEcocar. Vous pouvez nous joindre à contact@myecocar.fr. Pour ce faire, l'Utilisateur doit préciser sa qualité de Passager ou de Chauffeur, le motif de sa demande ainsi que le numéro de son trajet ou de sa réservation transmis dans les e-mails de confirmation de réservation. Ce service a pour objet principal de régler les litiges relatifs aux trajets effectués.</p>

                    <h3 class="subsection-title">2.7 Attestation du numéro</h3>
                    <p class="subsection-text"><strong>2.7.1</strong> Afin d'accroître son capital confiance et de faire face aux numéros obsolètes, il est obligatoire pour chaque Utilisateur de certifier son numéro de téléphone portable. Pour ce faire, l'Utilisateur reçoit un SMS sur lequel figure le code à 4 chiffres qu'il devra saisir dans le champ prévu à cet effet lors de la première inscription.</p>
                </section>

                <!-- Section 3 -->
                <section id="section3" class="cgu-section">
                    <h2 class="section-title">3. Responsabilité</h2>
                    
                    <p class="section-text">Le covoiturage résultant exclusivement de l'accord conclu entre le Conducteur et les Passagers, il apparaît que les utilisateurs du service agissent sous leur seule et entière responsabilité. En conséquence, MyEcocar étant un intermédiaire, le déroulement effectif du Trajet proposé par le Conducteur et accepté par le Passager ne saurait entraîner une quelconque responsabilité imputable à MyEcocar, quelle qu'en soit la cause.</p>

                    <p class="section-text">Il est impossible que MyEcocar soit tenu pour responsable d'un sinistre qui aurait pu survenir, notamment si :</p>

                    <ul class="responsibility-list">
                        <li>Le chauffeur a fourni des informations erronées sur le Trajet et ses modalités.</li>
                        <li>Le Conducteur ou le Passager a annulé le Trajet</li>
                        <li>Le Conducteur ou le Passager a commis un acte frauduleux, que ce soit avant, après ou pendant le Voyage.</li>
                    </ul>

                    <p class="section-text">En particulier, aucune forme de responsabilité ne pourra être retenue à l'encontre de MyEcocar si le Passager utilise frauduleusement un quelconque moyen (instrument) de paiement. Dans ce cas, MyEcocar n'apporte aucune garantie de paiement pour le Conducteur.</p>

                    <p class="subsection-text"><strong>3.2</strong> MyEcocar s'efforce d'assurer l'ouverture du Site et du service 24h/24 et 7j/7. S'il s'avère que l'accès au Site ou au service est interrompu en raison d'opérations de maintenance, de mises à niveau matérielles ou logicielles, de réparations urgentes du site, ou en raison de circonstances indépendantes de la volonté de MyEcocar, ce dernier s'engage à faire en sorte que ces perturbations soient limitées au maximum en prenant toutes les mesures appropriées.</p>

                    <p class="subsection-text"><strong>3.3</strong> Tout Utilisateur reconnaît et accepte que MyEcocar n'assume aucune responsabilité envers lui concernant l'indisponibilité, la suspension ou l'interruption du Site ou du service. MyEcocar ne pourra être tenu responsable des dommages en résultant, qu'ils soient directs ou indirects, et de quelque nature que ce soit.</p>

                    <p class="subsection-text"><strong>3.4</strong> Dans tous les cas, et sans préjudice de ce qui vient d'être exposé ci-dessus et dans les autres clauses relatives à l'absence de responsabilité de MyEcocar, toute cause de responsabilité qui pourrait être retenue à l'encontre de MyEcocar ne pourra donner lieu qu'au paiement de dommages et intérêts dont le montant sera limité aux sommes perçues au titre des Frais de service ou des Frais d'annulation (le cas échéant). Le prix fixé par le Chauffeur pour son annonce de covoiturage relève de sa seule responsabilité.</p>
                </section>

                <!-- Section 4 -->
                <section id="section4" class="cgu-section">
                    <h2 class="section-title">4. Interruption et suspension de l'accès au Site</h2>
                    
                    <p class="subsection-text"><strong>4.1</strong> En cas de non-respect de sa part de tout ou partie des CGU, ou pour toute autre raison objective, l'Utilisateur reconnaît et accepte que MyEcocar puisse procéder sans notification préalable et à tout moment, de manière temporaire ou définitive, à l'interruption ou à la suspension de tout ou partie du Service ou de son accès au Site, y compris notamment son Compte Utilisateur.</p>
                </section>

                <!-- Section 5 -->
                <section id="section5" class="cgu-section">
                    <h2 class="section-title">5. Traitement des données personnelles des utilisateurs du site</h2>
                    
                    <h3 class="subsection-title">5.1 Dispositions générales</h3>
                    <p class="subsection-text"><strong>5.1.1</strong> Conformément aux dispositions de la loi n° 78-17 du 6 janvier 1978 modifiée par la loi n° 2004-801 du 6 août 2004 relative à l'informatique, aux fichiers et aux libertés, MyEcocar a procédé le 9 avril 2014 auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) à la déclaration préalable du traitement qu'il opère sur les données personnelles concernant l'Utilisateur, conformément à la norme simplifiée n° 48 (délibération CNIL n° 2005-112 du 7 juin 2005 portant création d'une norme simplifiée relative aux traitements automatisés de données à caractère personnel relatifs à la gestion de fichiers de clients et de prospects - JO n°149 du 28 juin 2005). Numéro de déclaration 1826966v0.</p>

                    <p class="subsection-text"><strong>5.1.2</strong> Le traitement des données concernant l'Utilisateur relève de la responsabilité de MyEcocar. Conformément aux dispositions de la norme simplifiée n° 48, seuls les salariés et prestataires de services de MyEcocar qui exploitent le Site ou fournissent le service proposé ont accès aux données personnelles de l'Utilisateur. Une réponse exacte de la part de l'Utilisateur est nécessaire concernant les données présentées comme obligatoires dans le formulaire lui permettant de devenir utilisateur du Site et du service. En cas d'absence de réponse ou de réponse jugée anormale par MyEcocar, ce dernier pourra émettre un refus de prise en compte de la demande d'inscription de l'Utilisateur au service de MyEcocar.</p>

                    <h3 class="subsection-title">5.2 Transmission de données à caractère personnel à des tiers</h3>
                    <p class="subsection-text"><strong>5.2.1</strong> Conformément aux dispositions de la norme simplifiée n°48, MyEcocar se réserve le droit de transmettre tout ou partie des données personnelles concernant les Utilisateurs dans le strict respect de la norme simplifiée n°48 et de la loi Informatique et Libertés du 6 août 2004. Toute utilisation des données autre que celles spécifiées ci-dessus devra se faire après un consentement individuel et explicite des Utilisateurs.</p>

                    <p class="subsection-text"><strong>5.2.2</strong> Conformément à la loi n°78-17 du 6 janvier 1978, MyEcocar doit obtenir l'accord des Utilisateurs pour toute transmission de leurs données à des partenaires commerciaux à des fins d'opérations de marketing direct, au moyen d'une case à cocher.</p>

                    <h3 class="subsection-title">5.3 Droit d'accès, de rectification et d'opposition</h3>
                    <p class="subsection-text"><strong>5.3.1</strong> L'Utilisateur dispose d'un droit d'accès et de rectification des données personnelles le concernant, conformément à la loi n°78-17 du 6 janvier 1978, en s'adressant au Responsable du Site puis en remplissant et en envoyant le formulaire de contact sauf en ce qui concerne les données personnelles fournies à MyEcocar au moment où l'Utilisateur a rempli le formulaire d'adhésion en ligne, données qu'il lui appartient de modifier et de mettre à jour, comme le stipule l'article V.4 'Mise à jour des données personnelles'.</p>

                    <p class="subsection-text"><strong>5.3.2</strong> Conformément à la loi n°78-17 du 6 janvier 1978, tout Utilisateur a le droit de s'opposer gratuitement et sans frais à ce que les données personnelles le concernant soient utilisées par MyEcocar ou par ses partenaires commerciaux à des fins de prospection, notamment commerciale. Dans le cas où un Utilisateur exerce son droit d'opposition à ce titre directement auprès de MyEcocar, ce dernier s'engage à répercuter l'opposition émise par l'Utilisateur auprès des partenaires contractuels de MyEcocar auxquels il aurait pu transmettre les données personnelles dudit Utilisateur.</p>

                    <p class="subsection-text"><strong>5.3.3</strong> Conformément à la loi n°78-17 du 6 janvier 1978, MyEcocar doit s'assurer que les données personnelles concernant les Utilisateurs, même celles communiquées à d'éventuels partenaires commerciaux, ne sont pas diffusées hors de l'Union Européenne, sauf en cas d'autorisation expresse et de consentement préalable de l'Utilisateur à cet effet.</p>

                    <p class="subsection-text"><strong>5.3.4</strong> Conformément à la loi n°78-17 du 6 janvier 1978, MyEcocar se réserve le droit de transmettre les données personnelles des Utilisateurs, soit au titre d'une obligation légale, soit en application d'une décision administrative, judiciaire ou d'une décision d'une autorité administrative indépendante (notamment la Commission Nationale de l'Informatique et des Libertés).</p>

                    <h3 class="subsection-title">5.4 Mise à jour des données personnelles</h3>
                    <p class="subsection-text"><strong>5.4.1</strong> L'Utilisateur s'engage à assurer la mise à jour des données personnelles le concernant et veille à ce que celles-ci soient bien entendu complètes, exactes et non équivoques. Le compte utilisateur est accessible à tout moment à l'Utilisateur sur le Site au moyen de son mot de passe et de son identifiant.</p>

                    <h3 class="subsection-title">5.5 Sécurité des données personnelles</h3>
                    <p class="subsection-text"><strong>5.5.1</strong> Conformément à la loi n°78-17 du 6 janvier 1978 et en raison de la nature des données et des risques que présente le traitement des données personnelles de ses Utilisateurs, MyEcocar s'engage à prendre toutes les précautions utiles afin de préserver la sécurité de ces données et notamment d'empêcher qu'elles soient déformées, endommagées ou accessibles à des tiers non autorisés.</p>

                    <h3 class="subsection-title">5.6 L'hébergeur du site</h3>
                    <p class="subsection-text"><strong>5.6.1</strong> Aucun droit n'est conféré à l'hébergeur du Site quant à l'utilisation des données personnelles des utilisateurs auxquelles ledit hébergeur est susceptible d'avoir accès, sauf aux fins de réalisation de prestations techniques d'hébergement et de gestion de bases de données et exclusively dans le cadre des conditions contractuelles prévues et signées entre l'hébergeur et MyEcocar, qui ne peuvent déroger au présent article.</p>

                    <h3 class="subsection-title">5.7 Propriété intellectuelle</h3>
                    <p class="subsection-text"><strong>5.7.1</strong> MyEcocar est propriétaire du Site. Toute reproduction, même partielle, est soumise à l'autorisation préalable et écrite de MyEcocar. La reproduction d'éléments du Site par les visiteurs du Site est formellement interdite. Toute utilisation contraire de tout ou partie du Site constituerait une contrefaçon pouvant exposer le visiteur contrevenant à des poursuites civiles et pénales et aux sanctions mentionnées.</p>

                    <h3 class="subsection-title">5.8 Contenu du Site saisi par les Utilisateurs</h3>
                    <p class="subsection-text"><strong>5.8.1</strong> Le contenu saisi par les Utilisateurs du site n'engage en aucune manière la responsabilité de MyEcocar. Toutefois, dans le cas où il serait porté à la connaissance de MyEcocar qu'un contenu porte atteinte aux droits d'un tiers, MyEcocar prendra les mesures nécessaires pour supprimer immédiatement ce contenu litigieux.</p>

                    <h3 class="subsection-title">5.9 Sites partenaires</h3>
                    <p class="subsection-text"><strong>5.9.1</strong> L'acceptation des présentes CGU vaut acceptation de la publication sur le Site MyEcocar des informations renseignées lors de l'inscription.</p>

                    <p class="subsection-text"><strong>5.9.2</strong> Il est concédé à MyEcocar le droit de reproduire les informations figurant sur le Site ou sur l'un des sites partenaires, notamment les annonces publiées sur l'un des sites édités ou coédités par MyEcocar.</p>
                </section>

                <!-- Section 6 -->
                <section id="section6" class="cgu-section">
                    <h2 class="section-title">6. Covoiturage et assurance</h2>
                    
                    <p class="subsection-text"><strong>6.1</strong> L'assurance automobile est obligatoire (article L. 211-1 du Code des assurances). Le propriétaire d'un véhicule souhaitant se lancer dans le covoiturage doit souscrire au minimum une assurance responsabilité civile. Cette garantie couvre les dommages qui pourraient être causés à des tiers en cas d'incident.</p>

                    <p class="subsection-text"><strong>6.2</strong> Les passagers sont couverts. Il est toujours préférable de vérifier son contrat, car certaines situations peuvent être exclues des situations garanties. Il faut notamment vérifier que l'assurance en question couvre bien les trajets domicile-travail si c'est ce qui est prévu, et le prêt du volant si jamais le conducteur n'est pas le propriétaire du véhicule ou si le conducteur souhaite confier la conduite à une autre personne pendant le trajet.</p>

                    <p class="subsection-text">Sauf cas particulier, le covoiturage, qu'il soit occasionnel ou habituel, n'entraîne aucune modification du contrat d'assurance du conducteur.</p>

                    <p class="subsection-text">Une extension de garantie n'est donc en principe pas nécessaire. Pour rappel, le défaut d'assurance, y compris par négligence, constitue un délit. (article L. 324-2 du Code de la route).</p>

                    <p class="subsection-text"><strong>6.3</strong> le covoiturage entre particuliers ne doit pas donner lieu à rémunération pour le conducteur et doit se limiter au partage des frais d'utilisation du véhicule.</p>
                </section>

                <!-- Section 7 -->
                <section id="section7" class="cgu-section">
                    <h2 class="section-title">7. Litiges et opposition</h2>
                    
                    <p class="subsection-text"><strong>7.1</strong> Toute réclamation contre MyEcocar et en relation avec les présentes est prescrite par un délai d'un an. Si un paiement n'a pas été réclamé dans un délai d'un an, il est présumé que le Conducteur ou le Passager y a renoncé. Les sommes non réclamées reviennent de plein droit à MyEcocar. En cas de litige, la juridiction compétente sera considérée comme les tribunaux compétents du lieu du siège social de MyEcocar.</p>
                </section>
            </div>
        </div>

        <!-- Back to top button -->
        <div class="back-to-top">
            <a href="#top" class="back-to-top-btn">↑ Haut de la page</a>
        </div>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Découvrir</h4>
                        <ul class="footer-links">
                            <li><a href="#">Qui sommes-nous ?</a></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits réservés.
                </p>
            </div>
        </footer>
    </div>
</template>

<style>
/* Neutralise l'espace vide de layout sur la vue CGU */
.app-container.cgu,
.app-container.cgu main,
.app-container.cgu #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.cgu .view-container {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

/* Cache le footer global pour garder uniquement le footer custom de CGU */
.app-container.cgu .footer-component {
    display: none !important;
}
</style>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.cgu-page {
    background-color: #f8f9fa;
    min-height: 100vh;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    flex-direction: column;
}

/* Header Styling */
.cgu-header {
    background: linear-gradient(135deg, #2d5016 0%, #1f3f2e 100%);
    color: white;
    padding: 60px 20px;
    text-align: center;
}

.cgu-header-content {
    max-width: 1400px;
    margin: 0 auto;
}

.cgu-main-title {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 10px;
    line-height: 1.2;
}

.cgu-subtitle {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 300;
}

/* Main Container */
.cgu-container {
    width: min(1600px, 96vw);
    margin: 0 auto;
    padding: 40px 24px;
    flex: 1;
}

/* Table of Contents */
.cgu-toc {
    background-color: white;
    border-left: 5px solid #2d5016;
    padding: 30px;
    font-size: 18px;
    margin-bottom: 40px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.toc-title {
    font-size: 24px;
    color: #2d5016;
    margin-bottom: 20px;
    font-weight: 600;
}

.toc-list {
    list-style: decimal;
    padding-left: 30px;
}

.toc-list li {
    margin-bottom: 12px;
    line-height: 1.6;
}

.toc-link {
    color: #0066cc;
    text-decoration: none;
    transition: all 0.3s ease;
    font-weight: 500;
}

.toc-link:hover {
    color: #2d5016;
    text-decoration: underline;
}

/* Content Area */
.cgu-content {
    background-color: white;
    padding: 44px 52px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.cgu-section {
    margin-bottom: 50px;
    scroll-margin-top: 20px;
}

.cgu-section:not(:first-child) {
    padding-top: 30px;
    border-top: 2px solid #e9ecef;
}

.section-title {
    font-size: 28px;
    color: #2d5016;
    margin-bottom: 20px;
    font-weight: 700;
    padding-bottom: 15px;
    border-bottom: 3px solid #aef7b9;
    display: inline-block;
}

.subsection-title {
    font-size: 18px;
    color: #1f3f2e;
    margin-top: 25px;
    margin-bottom: 15px;
    font-weight: 600;
}

.section-text,
.subsection-text {
    color: #444;
    line-height: 1.8;
    margin-bottom: 15px;
    text-align: justify;
    font-size: 20px;
}

/* Definitions Box */
.definitions-box {
    background-color: #f0f8f3;
    border-left: 4px solid #4caf50;
    padding: 25px;
    margin: 25px 0;
    border-radius: 6px;
}

.definitions-box h3 {
    color: #2d5016;
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: 600;
}

.definitions-list {
    list-style: none;
    padding: 0;
}

.definitions-list dt {
    color: #1f3f2e;
    font-weight: 600;
    margin-top: 15px;
    margin-bottom: 8px;
    font-size: 18px;
}

.definitions-list dd {
    color: #555;
    margin-left: 20px;
    margin-bottom: 12px;
    line-height: 1.7;
    font-size: 16px;
}

/* Lists */
.responsibility-list {
    list-style: disc;
    padding-left: 30px;
    margin: 20px 0;
}

.responsibility-list li {
    color: #444;
    font-size: 18px;
    margin-bottom: 10px;
    line-height: 1.7;
}

/* Back to Top */
.back-to-top {
    text-align: center;
    padding: 30px 20px;
    background-color: #f8f9fa;
}

.back-to-top-btn {
    display: inline-block;
    padding: 12px 30px;
    background-color: #2d5016;
    color: white;
    text-decoration: none;
    border-radius: 5px;
    transition: all 0.3s ease;
    font-weight: 600;
    font-size: 14px;
}

.back-to-top-btn:hover {
    background-color: #1f3f2e;
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(45, 80, 22, 0.3);
}

/* Footer identique a Trips */
.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 2rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .cgu-header {
        padding: 40px 20px;
    }

    .cgu-main-title {
        font-size: 32px;
    }

    .cgu-subtitle {
        font-size: 16px;
    }

    .cgu-container {
        width: 100%;
        padding: 20px 12px;
    }

    .cgu-content {
        padding: 25px;
    }

    .cgu-toc {
        padding: 20px;
    }

    .toc-title {
        font-size: 20px;
    }

    .section-title {
        font-size: 22px;
    }

    .subsection-title {
        font-size: 16px;
    }

    .section-text,
    .subsection-text {
        font-size: 14px;
        text-align: left;
    }

    .definitions-box {
        padding: 15px;
    }

    .footer-section {
        padding: 2rem 1rem 1rem;
        margin-top: 2rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .cgu-header {
        padding: 30px 15px;
    }

    .cgu-main-title {
        font-size: 24px;
    }

    .cgu-subtitle {
        font-size: 14px;
    }

    .cgu-content {
        padding: 15px;
    }

    .section-title {
        font-size: 18px;
    }

    .subsection-title {
        font-size: 14px;
    }

    .toc-list {
        padding-left: 20px;
    }

    .toc-list li {
        margin-bottom: 8px;
        font-size: 14px;
    }

    .footer-section {
        padding: 1.5rem 1rem;
        margin-top: 1.5rem;
    }

    .footer-logo {
        width: 35px;
        height: 35px;
    }

    .footer-brand-name {
        font-size: 1.1rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.2rem;
    }

    .footer-column-title {
        font-size: 0.95rem;
    }

    .footer-links a {
        font-size: 0.85rem;
    }

    .social-link {
        width: 40px;
        height: 40px;
    }

    .social-link i {
        font-size: 1.1rem;
    }
}

@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}
</style>

<script>
import router from '../../router';
import bus from '../../services/bus-event.js';

export default {
    name: 'cgu',
    data() {
        return {};
    },
    mounted() {
        bus.on('back-click', this.onBackClick);
    },
    methods: {
        onBackClick() {
            router.back();
        }
    },
    beforeDestroy() {
        bus.off('back-click', this.onBackClick);
    }
};
</script>
